import { useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { TileHeaderSlot } from './tile-header-slot'

/**
 * Render a body renderer's controls into the enclosing tile's header row (title
 * on the left, controls on the right, one row). See tile-header-slot.ts.
 */
export function HeaderControls({ children }: { children: ReactNode }) {
  const slot = useContext(TileHeaderSlot)
  if (!slot) return null
  return createPortal(children, slot)
}
